var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 76,
    viewBox: "0 0 77 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.9319 29.4486C65.9319 36.7284 63.04 43.7101 57.8924 48.8577C52.7448 54.0053 45.7631 56.8972 38.4833 56.8972C31.2035 56.8972 24.2218 54.0053 19.0742 48.8577C13.9266 43.7101 11.0347 36.7284 11.0347 29.4486C11.0347 22.1688 13.9266 15.1871 19.0742 10.0395C24.2218 4.8919 31.2035 2 38.4833 2C45.7631 2 52.7448 4.8919 57.8924 10.0395C63.04 15.1871 65.9319 22.1688 65.9319 29.4486Z",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6078 14.5446L43.3906 22.1544C43.4747 22.3464 43.6082 22.5126 43.7775 22.6362C43.9468 22.7598 44.1458 22.8362 44.3543 22.8578L52.7561 24.1316C52.9966 24.1624 53.2232 24.2611 53.4095 24.4161C53.5958 24.5712 53.734 24.7762 53.8079 25.0071C53.8817 25.238 53.8882 25.4851 53.8265 25.7195C53.7648 25.9539 53.6375 26.1658 53.4595 26.3304L47.2509 32.2233C47.1587 32.3994 47.1106 32.5951 47.1106 32.7938C47.1106 32.9925 47.1587 33.1882 47.2509 33.3643L48.4417 41.7163C48.4933 41.9583 48.4734 42.2102 48.3843 42.441C48.2951 42.6719 48.1407 42.8718 47.9397 43.0164C47.7388 43.1609 47.5002 43.2437 47.2529 43.2548C47.0057 43.2659 46.7606 43.2047 46.5475 43.0787L39.0706 39.1243C38.8774 39.0371 38.6678 38.9921 38.4558 38.9921C38.2438 38.9921 38.0343 39.0371 37.8411 39.1243L30.3641 43.0787C30.1513 43.2013 29.9076 43.2597 29.6623 43.247C29.417 43.2343 29.1806 43.1509 28.9817 43.0069C28.7827 42.8629 28.6296 42.6645 28.5407 42.4355C28.4519 42.2065 28.4312 41.9568 28.4811 41.7163L29.8878 33.3643C29.9478 33.1706 29.959 32.965 29.9204 32.766C29.8817 32.5669 29.7944 32.3805 29.6663 32.2233L23.4687 26.2806C23.3022 26.114 23.1851 25.9045 23.1305 25.6754C23.0758 25.4462 23.0858 25.2065 23.1592 24.9826C23.2327 24.7588 23.3668 24.5598 23.5465 24.4076C23.7263 24.2554 23.9448 24.1561 24.1777 24.1206L32.574 22.9021C32.7825 22.8805 32.9815 22.8041 33.1508 22.6805C33.3201 22.557 33.4536 22.3907 33.5377 22.1987L37.3204 14.5889C37.4211 14.3729 37.5804 14.1895 37.7801 14.0595C37.9799 13.9295 38.2121 13.8581 38.4503 13.8535C38.6886 13.8489 38.9234 13.9112 39.128 14.0334C39.3326 14.1555 39.4988 14.3326 39.6078 14.5446Z",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7068 42.9126L2.5 64.0584L15.6871 60.5249L19.2262 73.712L29.8157 55.3686",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.293 42.9126L74.4998 64.0584L61.3072 60.5249L57.7736 73.712L47.1841 55.3686",
    stroke: "#1377D4",
    strokeWidth: 3.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBadge);
export default __webpack_public_path__ + "static/media/starBadge.ef0f4451383bb8f79e8200ee538032b2.svg";
export { ForwardRef as ReactComponent };